import { useState } from 'react';
import { Link } from 'react-router-dom';
import { signUp, sendEmailVerification, addUser } from '../../../firebase';
import { UseAuthContext } from '../../../context/AuthContext';

export default function Login() {
  const { user } = UseAuthContext();
  const [userName, setUserName] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [conPass, setConPass] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const createAccount = (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    setError("");
    if (validateForm(phone, email, pass, conPass)) {
      signUp(email, pass)
        .then(res => {
          sendEmailVerification(res.user).then(()=>{
            addUser({...user,
                id:res.user.uid, 
                email:email,
                name:userName,
                gender:gender,
                phone:phone,
            });
          });
          setLoading(false);
          resetForm();
        }).then(()=>{
          setMsg(`Successfully SignUp. Please verify your email before signIn. Verification mail sent to: ${email}`);
        }).catch(err => {
          setLoading(false);
          if (err.message.includes("email-already-in-use")) {
            setError("Account already exist. Please Sign In.");
          } else if (err.message.includes("invalid-email")) {
            setError("Invalid email.");
          } else if (err.message.includes("weak-password")) {
            setError("Password should be at least 6 characters.");
          } else {
            setError("SignUp Failed. Please contact us");
          }
        });
    } else {
      setLoading(false);
    }
  }
  const validateForm = (phone, e, p, c) => {
    let status = true;
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const rexPhone = /^[0-9]{10}$/;
    if(!rexPhone.test(phone)){
      setError("Invalid phone number");
      status = false;
    }
    else if (!re.test(String(e).toLowerCase())) {
      setError("Invalid email.");
      status = false;
    } else if (p !== c) {
      setError("Password and confirm password are not matched!");
      status = false;
    } else if (p.length < 6 || c.length < 6) {
      setError("Password should be at least 6 characters.");
      status = false;
    }
    return status;
  }
  const resetForm = () => {
    setUserName("");
    setPhone("");
    setGender("");
    setEmail("");
    setPass("");
    setConPass("");
  }

  return (

    <section id="contact" className="contact">

      <div className="container" data-aos="fade-down">
        <div className="login-title">
          <h2>Create Account </h2>
          <p>Please Sign-up to Continue!</p>
        </div>
      </div>
      <div className="row " style={{ justifyContent: "center" }}>
        <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={200}>
          <form className="php-email-form">
            <div className="row text-align-center g-2">
              <div className=" form-group col-md-6 ">
                <input type="text" className="form-control" name="user" placeholder="Name"
                  value={userName} onChange={(e) => setUserName(e.target.value)} required />
              </div>

              <div className=" form-group col-md-6 ">
                <input type="text" className="form-control" name="phone" placeholder="Phone" maxLength={10}
                  value={phone} onChange={(e) => setPhone(e.target.value)} required />
              </div>

              <div className=" form-group col-md-6 ">
                <input type="email" className="form-control" name="email" placeholder="email"
                  value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <div className=" form-group col-md-6 ">
                <select className="form-select" name="gender" value={gender} 
                onChange={(e) => setGender(e.target.value)}>
                  <option value="None">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className=" form-group col-md-6 ">
                <input type="password" className="form-control" name="password" placeholder="password"
                  value={pass} onChange={(e) => setPass(e.target.value)} required />
              </div>
              <div className="form-group col-md-6 ">
                <input type="password" className="form-control" name="conPass" placeholder="confirm password"
                  value={conPass} onChange={(e) => setConPass(e.target.value)} required />
              </div>
              {msg && <div className="alert alert-success" role="alert">{msg}</div>}
              {error && <div className="alert alert-danger" role="alert">{error}</div>}
              <div className="form-group col-md-12">
                {loading ? <button type="submit" disabled={true}>Wait</button> :
                  <button type="submit" disabled={!phone || !email || !pass || !conPass || !gender}
                    onClick={createAccount}>Signup</button>}
              </div>
            </div>
            <p className='my-2'>Already have an account? <Link to="/login">Signin</Link></p>
          </form>
        </div>
      </div>
      <br />
    </section>
  );
}